"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _draftJs = require("draft-js"),
    _CommentAssets = _interopRequireDefault(require("../../../CommentAssets")),
    _RichTextEditor = require("../../../../../RichTextEditor"),
    CommentTextEditor = function CommentTextEditor(_ref) {
  var onUpdateContent = _ref.onUpdateContent,
      placeholder = _ref.placeholder,
      editorState = _ref.editorState,
      inputType = _ref.inputType,
      onSave = _ref.onSave,
      disabled = _ref.disabled,
      onCancel = _ref.onCancel,
      _ref$assetIds = _ref.assetIds,
      assetIds = void 0 === _ref$assetIds ? [] : _ref$assetIds,
      commentId = _ref.commentId,
      onFilesChange = _ref.onFilesChange,
      organisationId = _ref.organisationId;
  return _react["default"].createElement(_RichTextEditor.RichTextEditor, {
    onUpdateContent: onUpdateContent,
    placeholder: placeholder,
    editorState: editorState,
    inputType: inputType,
    onSave: onSave,
    disabled: disabled,
    onCancel: onCancel,
    organisationId: organisationId,
    hideControls: !0
  }, _react["default"].createElement(_CommentAssets["default"], {
    assetIds: assetIds,
    commentId: commentId,
    canAdd: !disabled,
    onFilesChange: onFilesChange
  }));
},
    _default = CommentTextEditor;

exports["default"] = _default;